
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faEllipsisV as farEllipsisV,
    } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';

    export default {
        name: 'Dropdown',

        components: {
            FontAwesomeIcon,
        },

        props: {
            isDark: {
                type: Boolean,
                default: false,
            },
            toggleClass: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                icons: {
                    farEllipsisV,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'dropdown-more',
                    this.getDarkClass,
                ];
            },

            getDarkClass() {
                return this.isDark ? 'is-dark' : '';
            },
        },

        methods: {},
    };
